<template>
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-row v-show="!EventDetailShow">
        <el-row type="flex" justify="space-between" class="title-bar">
          <div>
            <div class="title-h3">알람 목록</div>
          </div>
          <div>
            <el-date-picker style="width: 250px" v-model="dateRange" type="daterange" :clearable="false" align="right" unlink-panels :range-separator="defaultDateRangeOptions.rangeSeparator"
              :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions"
              :default-time="defaultDateRangeOptions.defaultTime"></el-date-picker>
            <el-select v-model="searchType" style="width:140px" @change="initSearchType">
              <el-option v-for="item in searchTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-if="searchType === 'eventlevelId'" v-model="searchKeyword" style="width: 200px;" @change="onSearchEventHist">
              <el-option v-for="item in eventlevelInfo" :key="item.eventlevelId" :label="item.eventlevelName" :value="item.eventlevelId"></el-option>
            </el-select>
            <el-select v-else-if="searchType === 'eventType'" v-model="searchKeyword" style="width: 200px;" @change="onSearchEventHist">
              <el-option v-for="item in logEventType" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
            </el-select>
            <el-input v-else style="width:200px" clearable placeholder="검색어를 입력해주세요." v-model="searchKeyword"
              @clear="onClearKeyword" @keyup.enter.native="onSearchEventHist" suffix-icon="el-icon-search"></el-input>
            <el-button size="small" style="height:28px !important" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
          </div>
        </el-row>
        <el-table-wrapper ref="eventTable" v-loading="loading" :column-default="columnDefault" :total="total" :data="eventHistData" :columns="eventHistColumns" :pagination="true" highlight-current-row
          @cell-click="onCellClick" @pagination-change="onCurrentPageChange">
          <template slot-scope="scope" slot="eventlevel-slot">
            <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
          </template>
          <template slot-scope="scope" slot="event-name">
            <span class="link" @click="onEventClick">{{ scope.row.eventInfo.eventName }}</span>
          </template>
          <template slot-scope="scope" slot="check-datetime-slot">
            {{ getDateToString(scope.row.checkDatetime, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-wrapper>
      </el-row>
      <w-event-detail v-show="EventDetailShow" :event-detail-show.sync="EventDetailShow" :selected-event="selectedRow" :now-index="nowIndex"
        :event-data="eventHistData" :active="active" @load-data="loadData" @click-event-subject="onCellClick" />
    </div>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex';
import { findIndex, isEmpty } from 'lodash';
import moment from 'moment';

import LogAPI from '@/api/log/integrated-log';
import FileAPI from '@/api/common/file';

import { columnDefault } from '@/constants/table';
import ScrollbarMixin from '@/mixins/scrollbar';
import { getDateToString, defaultDateRangeOptions } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtils from '@/utils/message';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WEventDetail from './EventDetail';

export default {
  name: 'WEvent',
  mixins: [ScrollbarMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WEventlevelCell,
    WEventDetail,
  },
  data() {
    const startDatetime = moment()
      .startOf('day')
      .toDate();
    const endDatetime = moment()
      .endOf('day')
      .toDate();
    return {
      loading: false,
      dateRange: [startDatetime, endDatetime],
      searchTypeOption: [
        { label: '등급', value: 'eventlevelId' },
        { label: '알람 종류', value: 'eventType' },
        { label: '알람명', value: 'eventName' },
        { label: '처리 내용', value: 'comment' },
        { label: '처리자', value: 'writerId' },
      ],
      total: null,
      start: 0,
      limit: 50,
      searchType: 'eventName',
      searchKeyword: null,
      defaultDateRangeOptions,
      EventDetailShow: false,
      selectAlram: {},
      columnDefault,
      logEventType: [],
      eventHistData: [],
      eventHistColumns: [
        {
          prop: 'eventlevelId',
          label: '등급',
          width: 90,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          remoteProp: 'eventlevelId',
          className: 'eventlevel',
        },
        {
          label: '알람 종류',
          prop: 'eventTypeLabel',
          width: 150,
          formatter: this.stringFormatter,
        },
        {
          label: '알람명',
          prop: 'eventInfo.eventName',
          scopedSlot: 'event-name',
          width: 250,
          formatter: this.stringFormatter,
        },
        {
          label: '발생 조건',
          prop: 'eventConditionLabel',
          formatter: this.stringFormatter,
        },
        {
          label: '발생 값',
          prop: 'eventOccurValueLabel',
          width: 150,
          formatter: this.stringFormatter,
        },
        {
          label: '처리자',
          prop: 'writerId',
          width: 150,
          formatter: this.stringFormatter,
        },
        {
          label: '발생 시각',
          prop: 'checkDatetime',
          scopedSlot: 'check-datetime-slot',
          width: 200,
        },
      ],
      selectedRow: null,
      nowIndex: -1,
    };
  },
  computed: mapGetters(['eventlevelInfo']),
  watch: {
    active(value) {
      if (value) {
        this.EventDetailShow = false;
        this.$refs.eventTable.setCurrentPage(1);
      }
    },
    dateRange() {
      if (this.active) {
        this.$refs.eventTable.setCurrentPage(1);
      }
    },
  },
  mounted() {
    this.setScrollData();
    LogAPI.getEventTypes().then((response) => {
      if (response.data.success) {
        this.logEventType = response.data.data;
      }
    }).catch((e) => {
      this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '알람 타입', false));
      throw new Error(e);
    });
  },
  methods: {
    getDateToString,
    /**
     * 발생한 로그 이벤트 이력 목록 조회
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        checkDatetime: this.dateRange[0],
        endCheckDatetime: this.dateRange[1],
        start: this.start,
        limit: this.limit,
      };
      if (!isEmpty(this.searchKeyword)) {
        params.searchType = this.searchType;
        params.searchKeyword = this.searchKeyword;
      }
      this.loading = true;
      LogAPI.getLogEventHists(params).then((response) => {
        if (response.data.success) {
          this.eventHistData = response.data.data;
          this.total = response.data.total;
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 알람 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 알람 목록', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    onCurrentPageChange(page) {
      this.limit = page.pageSize;
      this.start = (page.currentPage - 1) * this.limit;
      this.loadData();
    },
    /**
     * 엑셀 출력
     * @author Minyeong
     * @return {[type]} [description]
     */
    exportExcel() {
      const params = {
        checkDatetime: this.dateRange[0],
        endCheckDatetime: this.dateRange[1],
      };
      if (!isEmpty(this.searchKeyword)) {
        params.searchType = this.searchType;
        params.searchKeyword = this.searchKeyword;
      }
      this.loading = true;
      LogAPI.createLogEventExcel(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileAPI.downloadExportedExcelFile(response.data.data);
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.OUTPUT, '로그 알람 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.OUTPUT, '로그 알람 목록', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    initSearchType() {
      this.searchKeyword = '';
      this.loadData();
    },
    onSearchEventHist() {
      this.$refs.eventTable.setCurrentPage(1);
    },
    stringFormatter(row, column, value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return value;
    },
    onEventClick() {
      this.EventDetailShow = !this.EventDetailShow;
    },
    onCellClick(row) {
      this.selectedRow = row;
      this.nowIndex = findIndex(this.eventHistData, (item) => item === this.selectedRow);
    },
    onClearKeyword() {
      this.searchKeyword = null;
      this.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/Event/index.vue